import styled from 'styled-components'
import { Form } from 'formik'

import theme from 'theme_'

export const StyledForgotPasswordForm = styled(Form)`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 347px;
  padding: 5px;
  margin: 0 auto;

  @media ${theme.devices.tablet} {
    max-width: 471px;
    padding: 0;
  }

  @media ${theme.devices.mobile} {
    padding: 24px;
  }
`

export const SubmitEmailWrapper = styled.div`
  margin: 0 auto;
  width: 70%;
  display: inline-flex;
  justify-content: center;
  gap: 16px;
  & > * {
    flex: 1;
  }

  @media ${theme.devices.mobile} {
    width: inherit;
    margin-top: 12px;
    flex-direction: column;
    & > * {
      width: 100%;
    }
  }
`
